/**
 * @generated SignedSource<<2c8f2badc2c60b435becfeba57d06815>>
 * @relayHash 80eb72aab5c13c8990165327fb09912f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80eb72aab5c13c8990165327fb09912f

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteEpisodesOfCareInput = {
  ids: ReadonlyArray<string>;
};
export type deDeleteEpisodesOfCareMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_deleteEpisodesOfCareInput;
};
export type deDeleteEpisodesOfCareMutation$data = {
  readonly deleteEpisodesOfCare: {
    readonly de_EpisodeOfCare: ReadonlyArray<{
      readonly id: string;
    }> | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deDeleteEpisodesOfCareMutation = {
  response: deDeleteEpisodesOfCareMutation$data;
  variables: deDeleteEpisodesOfCareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deDeleteEpisodesOfCareMutation",
    "selections": [
      {
        "alias": "deleteEpisodesOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteEpisodesOfCarePayload",
        "kind": "LinkedField",
        "name": "de_deleteEpisodesOfCare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "de_EpisodeOfCare",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deDeleteEpisodesOfCareMutation",
    "selections": [
      {
        "alias": "deleteEpisodesOfCare",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteEpisodesOfCarePayload",
        "kind": "LinkedField",
        "name": "de_deleteEpisodesOfCare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_EpisodeOfCare",
            "kind": "LinkedField",
            "name": "de_EpisodeOfCare",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "80eb72aab5c13c8990165327fb09912f",
    "metadata": {},
    "name": "deDeleteEpisodesOfCareMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a2168a1c605c50bc7545658ad0bb92d7";

export default node;
